import api from "../network/apiConfig";

/**
 * Generates error from the error object
 * @param {Object} error The error object
 * @returns {Object} The generated error
 */
function errorGenerator(error) {
  const info = {};

  if (error?.response) {
    Object.assign(info, {
      data: error.response.data,
      error: error.response.status,
    });
  } else {
    Object.assign(info, {
      data: { message: "Something went wrong" },
      error: "Bad Network",
    });
  }

  return info;
}

/**
 * Logs a user in by calling proper API
 * @param {Object} data contains username password
 * @returns {Object} Login response
 */
const createUser = async (data) => {
  try {
    const result = await api.post("/user", data);
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const getUsersList = async () => {
  try {
    const result = await api.get("/user");
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const updateUser = async (user, username) => {
  try {
    const result = await api.patch(`/user/${username}`, user);
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const deleteUser = async (user, username) => {
  try {
    const result = await api.delete(`/user/${username}`, user);
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

const updateUserPassword = async (body, username) => {
  try {
    const result = await api.post(`/user/${username}/update-password`, body);
    if (result.data) {
      const info = { data: result.data, error: null };
      return info;
    }
    return errorGenerator({});
  } catch (error) {
    return errorGenerator(error);
  }
};

export { createUser, getUsersList, updateUser, deleteUser, updateUserPassword };
